/**
 * 模拟考试卡片
 */
export default {
  difficulty: '難度',
  mockDuration: '考試時長',
  intro: '簡介',
}
